// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { CategoriesApiListResponse, CategoriesApiGetData, CategoriesApiGetResponse, InstalledSoftwareApiSaveInstalledSoftwareData, InstalledSoftwareApiSaveInstalledSoftwareResponse, SoftwareApiListData, SoftwareApiListResponse, SoftwareApiGetData, SoftwareApiGetResponse, SoftwareApiGetSofwareVersionsData, SoftwareApiGetSofwareVersionsResponse, SoftwareApiGetLatestSofwareVersionsData, SoftwareApiGetLatestSofwareVersionsResponse, SoftwareAdminApiListData, SoftwareAdminApiListResponse, SoftwareAdminApiStatusesResponse, SoftwareAdminApiCreateData, SoftwareAdminApiCreateResponse, SoftwareAdminApiUploadCoverFileData, SoftwareAdminApiUploadCoverFileResponse, SoftwareAdminApiUploadFileData, SoftwareAdminApiUploadFileResponse, SoftwareAdminApiUpdateData, SoftwareAdminApiUpdateResponse, SoftwareAdminApiCreateVersionData, SoftwareAdminApiCreateVersionResponse, SoftwareAdminApiUpdateVersionData, SoftwareAdminApiUpdateVersionResponse, SoftwareAdminApiDeleteVersionData, SoftwareAdminApiDeleteVersionResponse, SoftwareAdminApiUpdateCategoryData, SoftwareAdminApiUpdateCategoryResponse, VersionsApiListData, VersionsApiListResponse, VersionsApiGetData, VersionsApiGetResponse } from './types.gen';

export class CategoriesApi {
    /**
     * List
     * @returns CategorySchema OK
     * @throws ApiError
     */
    public static list(): CancelablePromise<CategoriesApiListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/categories/'
        });
    }
    
    /**
     * Get
     * @param data The data for the request.
     * @param data.id
     * @returns CategorySchema OK
     * @throws ApiError
     */
    public static get(data: CategoriesApiGetData): CancelablePromise<CategoriesApiGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/categories/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class InstalledSoftwareApi {
    /**
     * Save Installed Software
     * @param data The data for the request.
     * @param data.requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static saveInstalledSoftware(data: InstalledSoftwareApiSaveInstalledSoftwareData): CancelablePromise<InstalledSoftwareApiSaveInstalledSoftwareResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/installed-software/save/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class SoftwareApi {
    /**
     * List
     * @param data The data for the request.
     * @param data.order
     * @param data.limit
     * @param data.search
     * @param data.categoryIn
     * @param data.category
     * @param data.status
     * @param data.statusNot
     * @returns SoftwareListSchema OK
     * @throws ApiError
     */
    public static list(data: SoftwareApiListData = {}): CancelablePromise<SoftwareApiListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software/',
            query: {
                order: data.order,
                limit: data.limit,
                search: data.search,
                category__in: data.categoryIn,
                category: data.category,
                status: data.status,
                status_not: data.statusNot
            }
        });
    }
    
    /**
     * Get
     * @param data The data for the request.
     * @param data.id
     * @returns SoftwareSchema OK
     * @throws ApiError
     */
    public static get(data: SoftwareApiGetData): CancelablePromise<SoftwareApiGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Get Sofware Versions
     * @param data The data for the request.
     * @param data.id
     * @returns VersionSchema OK
     * @throws ApiError
     */
    public static getSofwareVersions(data: SoftwareApiGetSofwareVersionsData): CancelablePromise<SoftwareApiGetSofwareVersionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software/{id}/versions/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Get Latest Sofware Versions
     * @param data The data for the request.
     * @param data.id
     * @returns VersionSchema OK
     * @throws ApiError
     */
    public static getLatestSofwareVersions(data: SoftwareApiGetLatestSofwareVersionsData): CancelablePromise<SoftwareApiGetLatestSofwareVersionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software/{id}/latest_versions/',
            path: {
                id: data.id
            }
        });
    }
    
}

export class SoftwareAdminApi {
    /**
     * List
     * @param data The data for the request.
     * @param data.ordering
     * @param data.query
     * @param data.category
     * @param data.status
     * @param data.hasBlankVersionUrls
     * @param data.hasPendingVersions
     * @param data.limit
     * @param data.offset
     * @returns PagedAdminSoftwareListSchema OK
     * @throws ApiError
     */
    public static list(data: SoftwareAdminApiListData = {}): CancelablePromise<SoftwareAdminApiListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software-admin/',
            query: {
                ordering: data.ordering,
                query: data.query,
                category: data.category,
                status: data.status,
                has_blank_version_urls: data.hasBlankVersionUrls,
                has_pending_versions: data.hasPendingVersions,
                limit: data.limit,
                offset: data.offset
            }
        });
    }
    
    /**
     * Statuses
     * @returns unknown OK
     * @throws ApiError
     */
    public static statuses(): CancelablePromise<SoftwareAdminApiStatusesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/software-admin/statuses/'
        });
    }
    
    /**
     * Create
     * @param data The data for the request.
     * @param data.requestBody
     * @returns SoftwareSchema OK
     * @throws ApiError
     */
    public static create(data: SoftwareAdminApiCreateData): CancelablePromise<SoftwareAdminApiCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/software-admin/software/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Upload Cover File
     * @param data The data for the request.
     * @param data.id
     * @returns unknown OK
     * @throws ApiError
     */
    public static uploadCoverFile(data: SoftwareAdminApiUploadCoverFileData): CancelablePromise<SoftwareAdminApiUploadCoverFileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/software-admin/software/{id}/upload-cover-file/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Upload File
     * @param data The data for the request.
     * @param data.formData
     * @returns unknown OK
     * @throws ApiError
     */
    public static uploadFile(data: SoftwareAdminApiUploadFileData): CancelablePromise<SoftwareAdminApiUploadFileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/software-admin/upload-file/',
            formData: data.formData,
            mediaType: 'multipart/form-data'
        });
    }
    
    /**
     * Update
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns SoftwareSchema OK
     * @throws ApiError
     */
    public static update(data: SoftwareAdminApiUpdateData): CancelablePromise<SoftwareAdminApiUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/software-admin/software/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Create Version
     * @param data The data for the request.
     * @param data.softwareId
     * @returns string OK
     * @throws ApiError
     */
    public static createVersion(data: SoftwareAdminApiCreateVersionData): CancelablePromise<SoftwareAdminApiCreateVersionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/software-admin/software/{software_id}/create_version/',
            path: {
                software_id: data.softwareId
            }
        });
    }
    
    /**
     * Update Version
     * @param data The data for the request.
     * @param data.id
     * @param data.requestBody
     * @returns VersionSchema OK
     * @throws ApiError
     */
    public static updateVersion(data: SoftwareAdminApiUpdateVersionData): CancelablePromise<SoftwareAdminApiUpdateVersionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/software-admin/version/{id}/',
            path: {
                id: data.id
            },
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Delete Version
     * @param data The data for the request.
     * @param data.id
     * @returns unknown OK
     * @throws ApiError
     */
    public static deleteVersion(data: SoftwareAdminApiDeleteVersionData): CancelablePromise<SoftwareAdminApiDeleteVersionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/software-admin/version/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
    /**
     * Update Category
     * @param data The data for the request.
     * @param data.requestBody
     * @returns AdminUpdateCategorySchema OK
     * @throws ApiError
     */
    public static updateCategory(data: SoftwareAdminApiUpdateCategoryData): CancelablePromise<SoftwareAdminApiUpdateCategoryResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/software-admin/categories/',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class VersionsApi {
    /**
     * List
     * @param data The data for the request.
     * @param data.status
     * @param data.versionIsBlank
     * @param data.ids
     * @param data.offset
     * @param data.limit
     * @returns VersionSchema OK
     * @throws ApiError
     */
    public static list(data: VersionsApiListData = {}): CancelablePromise<VersionsApiListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/versions/',
            query: {
                status: data.status,
                versionIsBlank: data.versionIsBlank,
                ids: data.ids,
                offset: data.offset,
                limit: data.limit
            }
        });
    }
    
    /**
     * Get
     * @param data The data for the request.
     * @param data.id
     * @returns VersionSchema OK
     * @throws ApiError
     */
    public static get(data: VersionsApiGetData): CancelablePromise<VersionsApiGetResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/versions/{id}/',
            path: {
                id: data.id
            }
        });
    }
    
}